import { render, staticRenderFns } from "./ReferralCouponSection.vue?vue&type=template&id=4e0b4c93&scoped=true"
import script from "./ReferralCouponSection.vue?vue&type=script&lang=ts"
export * from "./ReferralCouponSection.vue?vue&type=script&lang=ts"
import style0 from "./ReferralCouponSection.vue?vue&type=style&index=0&id=4e0b4c93&prod&lang=scss&scoped=true"
import style1 from "./ReferralCouponSection.vue?vue&type=style&index=1&id=4e0b4c93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b4c93",
  null
  
)

export default component.exports